import axios, {AxiosResponse} from "axios";
import {Cache} from "./Cache"
import {Geolocation, GeolocationApiResponse} from "@/models/GeolocationModel";
import {configuration} from "@/composables/ConfigurationComposition";

const geolocationCache = new Cache<Geolocation[]>();

/**
 * fetch geolocations by input query
 *
 * @param input
 * @param country
 */
export function fetchGeolocations(input: string, country: string): Promise<Geolocation[]> {
    const buildUrl = () => {
        input = input.trim();
        const key = configuration.geoapifyKey;
        const lang = configuration.geoapifyLang.toLowerCase();
        const filter = configuration.geoapifyFilter;
        const type =  (input.match(/^([\d\\-]*)$/gm)) ? 'postcode' : 'city';

        let url = `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURI(input)}&type=${type}&lang=${lang}&limit=15&apiKey=${key}&filter=countrycode:${country}`;

        if (country === '' && filter.length) {
            url += `&filter=countrycode:${filter.map(f => f.toLowerCase()).join(',')}`;
        } else {
            url += `&filter=countrycode:${country}`;
        }

        return url;
    }

    return new Promise<Geolocation[]>((resolve) => {
        const url = buildUrl();
        const cachedData = geolocationCache.get(url);

        if (cachedData !== undefined) {
            resolve(cachedData);
        } else {
            axios
                .get(url)
                .then((response: AxiosResponse<GeolocationApiResponse>) => {
                    const result = response.data.features.map((feature) => {
                        const {properties} = feature;

                        let districtString;

                        if (properties.district) {
                            districtString = properties.district;
                        } else if (properties.suburb){
                            districtString = properties.suburb;
                        }

                        let cityString;

                        if (districtString) {
                            cityString = districtString + ' ' + (properties.city ? '(' + properties.city + ')' : null);
                        } else {
                            cityString = properties.city ?? null;
                        }

                        const formatted = undefined !== properties.formatted ? properties.formatted : [
                            properties.postcode ?? null,
                            cityString,
                            properties.country,
                        ].filter(value => value !== null).join(', ')

                        return {
                            country: properties.country_code,
                            formatted: formatted,
                            place_id: properties.place_id,
                            lat: properties.lat,
                            lng: properties.lon
                        } as Geolocation;
                    });

                    geolocationCache.set(url, result);

                    resolve(result);
                })
                .catch(e => {
                    resolve([]);
                });
        }
    });
}

